import Symbol from './Symbol';
import SymbolMap from './SymbolMap';
import { DEFAULT_SYMBOL_MAP } from '@/pages/dsst-shinhan/dsstConfig';

interface GuideScreenProps {
  onStart: () => void;
  setIndex: number;
}

const EXAMPLE_SYMBOL = 0; // 보석
const EXAMPLE_NUMBER = DEFAULT_SYMBOL_MAP[EXAMPLE_SYMBOL]; // 1

// 게임 소개: 게임명 + 1~2줄 설명 + 자동 미니 데모 + 연습 시작
// 두뇌풀기 워밍업 화면 없이 바로 이 게임 소개부터 시작한다.
export default function GuideScreen({ onStart, setIndex }: GuideScreenProps) {
  return (
    <div className="flex flex-col h-full bg-white px-6 animate-fade-in-up">
      {/* Visual Anchor: 게임명 → 설명 → Mini Demo 를 하나의 그룹으로 묶는다 */}
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        <div className="m-auto w-full flex flex-col items-center">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-[28px] font-bold text-foreground-950 leading-tight tracking-tight">
              기호 맞추기
            </h1>
            <span className="mt-2.5 inline-flex items-center h-7 px-3 rounded-full bg-primary-50 text-primary-700 text-[13px] font-bold whitespace-nowrap">
              #집중력
            </span>
            <p className="text-[15px] leading-relaxed text-foreground-600 mt-3">
              45초 동안 기호와 짝이 되는 숫자를
              <br />
              최대한 많이 맞춰주세요.
            </p>
          </div>

          {/* Mini Demo: 기호-숫자 대응표 + 대표 예시 */}
          <div className="mt-8 w-full rounded-2xl bg-secondary-50 border border-secondary-100 px-5 py-8">
            <SymbolMap
              symbolMap={DEFAULT_SYMBOL_MAP}
              setIndex={setIndex}
              symbolSizeClass="w-9 h-9"
            />
            <div className="mt-9 flex items-center justify-center gap-5">
              <div className="flex items-center justify-center text-primary-600">
                <Symbol
                  symbolId={EXAMPLE_SYMBOL}
                  setIndex={setIndex}
                  className="w-16 h-16"
                />
              </div>
              <i className="ri-arrow-right-line text-foreground-300 text-2xl leading-none" />
              <div className="w-[68px] h-[68px] rounded-2xl bg-primary-600 text-white flex items-center justify-center text-2xl font-bold">
                {EXAMPLE_NUMBER}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-[calc(20px+env(safe-area-inset-bottom))]">
        <button
          onClick={onStart}
          className="w-full h-14 rounded-xl bg-primary-600 text-white font-semibold text-base whitespace-nowrap
            active:scale-[0.99] transition-transform duration-150 hover:bg-primary-700 cursor-pointer"
        >
          게임 시작
        </button>
      </div>
    </div>
  );
}